import { Controller } from "@hotwired/stimulus"

// Opens the browser print dialog. Used by the order shipping slip so the
// print button works without an inline <script> (CSP-safe under Turbo).
//
//   <button data-controller="print" data-action="click->print#print">Imprimer</button>
export default class extends Controller {
  print() {
    window.print()
  }
}
